/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query'
import type {
	UseQueryOptions,
	UseQueryResult,
	UseSuspenseQueryOptions,
	UseSuspenseQueryResult,
} from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { userListInvitations } from '../../axios/userListInvitations'
import type {
	UserListInvitationsError,
	UserListInvitationsQueryParams,
	UserListInvitationsResponse,
} from '../../types/UserListInvitations'

export const userListInvitationsQueryKey = (params?: UserListInvitationsQueryParams) =>
	[{ url: '/invitations' }, ...(params ? [params] : [])] as const

export type UserListInvitationsQueryKey = ReturnType<typeof userListInvitationsQueryKey>

/** @see backend/nexus/modules/Organisation/Http/Controllers/UserController.php UserController::listInvitations */
export function userListInvitationsQueryOptions(params?: UserListInvitationsQueryParams, config?: AxiosRequestConfig) {
	return queryOptions<
		UserListInvitationsResponse,
		AxiosError<UserListInvitationsError>,
		UserListInvitationsResponse,
		UserListInvitationsQueryKey
	>({
		queryKey: userListInvitationsQueryKey(params),
		queryFn: ({ signal }) => userListInvitations(params, { signal, ...config }).then(res => res.data),
	})
}

/** @see backend/nexus/modules/Organisation/Http/Controllers/UserController.php UserController::listInvitations */
export function useUserListInvitations<TSelectData = UserListInvitationsResponse>(
	params?: UserListInvitationsQueryParams,
	options?:
		& Partial<
			Omit<
				UseQueryOptions<
					UserListInvitationsResponse,
					AxiosError<UserListInvitationsError>,
					TSelectData,
					UserListInvitationsQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseQueryResult<TSelectData, AxiosError<UserListInvitationsError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useQuery({
		...userListInvitationsQueryOptions(params),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}

/** @see backend/nexus/modules/Organisation/Http/Controllers/UserController.php UserController::listInvitations */
export function useUserListInvitationsSuspense<TSelectData = UserListInvitationsResponse>(
	params?: UserListInvitationsQueryParams,
	options?:
		& Partial<
			Omit<
				UseSuspenseQueryOptions<
					UserListInvitationsResponse,
					AxiosError<UserListInvitationsError>,
					TSelectData,
					UserListInvitationsQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseSuspenseQueryResult<TSelectData, AxiosError<UserListInvitationsError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useSuspenseQuery({
		...userListInvitationsQueryOptions(params),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}
